/** Small built-in emoji set for reactions and the composer (no emoji library). */
export const quickReactions = [
  { emoji: '👍', label: 'thumbs up' },
  { emoji: '❤️', label: 'heart' },
  { emoji: '😂', label: 'laughing' },
  { emoji: '✅', label: 'check mark' },
  { emoji: '👀', label: 'eyes' },
  { emoji: '🙌', label: 'raised hands' },
  { emoji: '🎉', label: 'party' },
  { emoji: '🙏', label: 'thank you' },
] as const

export function emojiLabel(emoji: string): string {
  return quickReactions.find((r) => r.emoji === emoji)?.label ?? emoji
}
